import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode removed — it causes every useEffect to run twice in development
// which doubles all API calls and burns through the 500 connections/hour limit
root.render(<App />);
